<script>
export default {
  props: {
    batch: Number,
    title: String,
    code: String,
    date: String,
    time: String,
    competencies: Array,
    data: Object,
    isSimulasi: Boolean,
    adaYangSedangDikerjakan: Function,
    pindahKeHalamanTujuan: {
      type: Function,
      required: true,
    },
    isDateBetweenStartAndEnd: {
      type: Function,
      required: true,
    },
  },

  computed: {
    collapseId() {
      return `mym-collapse-${this.batch}-${this.data.kode_job}`;
    },

    waktuMulai() {
      let date = this.date_waktu_mulai.split(" ")[0];
      const [y, m, d] = date.split("-");
      return `${d}-${m}-${y}`;
    },
    waktuSelesai() {
      let date = this.date_waktu_selesai.split(" ")[0];
      const [y, m, d] = date.split("-");
      return `${d}-${m}-${y}`;
    },

    hariMulai() {
      return new Date(this.date_waktu_mulai).toLocaleDateString("id-ID", {
        weekday: "long",
      });
    },
    hariSelesai() {
      return new Date(this.date_waktu_selesai).toLocaleDateString("id-ID", {
        weekday: "long",
      });
    },

    jamMulai() {
      let date = this.date_waktu_mulai.split(" ")[1].slice(0, 5);
      return date;
    },

    jamSelesai() {
      let date = this.date_waktu_selesai.split(" ")[1].slice(0, 5);
      return date;
    },
  },

  data() {
    return {
      date_waktu_mulai: this.data.waktu_mulai,
      date_waktu_selesai: this.data.waktu_selesai,
    };
  },
};
</script>

<template>
  <div class="mym-card">
    <!-- Header -->
    <div class="mym-card-header">
      <span class="mym-badge mym-badge-primary">Batch {{ batch }}</span>
      <span class="mym-badge mym-soft-badge-success">Terjadwal</span>
    </div>

    <!-- Target -->
    <div class="mym-card-box">
      <div class="mym-card-title">Jabatan Target Asesmen</div>
      <div class="mym-card-subtitle">{{ data.jabatan_nama }}</div>
      <div class="mym-card-code">{{ data.kode_job }} - {{ data.nama_job }}</div>
    </div>

    <!-- Schedule -->
    <table class="mym-datetime-table">
      <tr>
        <td>
          <span class="mym-datetime-card mym-datetime-card-primary">
            <i class="far fa-calendar-alt mym-datetime-icon"></i>

            <span class="mym-datetime-main">
              {{ waktuMulai }}
            </span>

            <span class="mym-datetime-vline"></span>

            <span class="mym-datetime-side">
              {{ hariMulai }}
            </span>
          </span>
        </td>

        <td class="mym-datetime-middle" rowspan="2">s/d</td>

        <td>
          <span class="mym-datetime-card mym-datetime-card-danger">
            <i class="far fa-clock mym-datetime-icon"></i>

            <span class="mym-datetime-main">
              {{ jamMulai }}
            </span>

            <span class="mym-datetime-vline"></span>

            <span class="mym-datetime-side"> WIB </span>
          </span>
        </td>
      </tr>

      <tr>
        <td>
          <span
            class="mym-datetime-card mym-datetime-card-primary active-primary"
          >
            <i class="far fa-calendar-alt mym-datetime-icon"></i>

            <span class="mym-datetime-main">
              {{ waktuSelesai }}
            </span>

            <span class="mym-datetime-vline"></span>

            <span class="mym-datetime-side">
              {{ hariSelesai }}
            </span>
          </span>
        </td>

        <td>
          <span
            class="mym-datetime-card mym-datetime-card-danger active-danger"
          >
            <i class="far fa-clock mym-datetime-icon"></i>

            <span class="mym-datetime-main">
              {{ jamSelesai }}
            </span>

            <span class="mym-datetime-vline"></span>

            <span class="mym-datetime-side"> WIB </span>
          </span>
        </td>
      </tr>
    </table>

    <!-- Kompetensi -->
    <div class="mym-card-collapse">
      <input type="checkbox" :id="collapseId" class="mym-collapse-toggle" />

      <label
        v-if="data.list_kompetensi.length > 0"
        :for="collapseId"
        class="mym-collapse-header fw-bold mym-bg-primary"
      >
        <span>
          <i class="far fa-file-alt me-1"></i>
          Ikuti Asesmen
        </span>

        <i class="fa fa-chevron-down mym-arrow"></i>
      </label>

      <label v-else class="mym-collapse-header fw-bold">
        <span>
          <i class="far fa-file-alt me-1"></i>
          Ikuti Asesmen
        </span>
      </label>

      <div class="mym-collapse-body">
        <fieldset
          class="border p-3 rounded"
          style="border-color: #e5e7eb !important"
        >
          <legend class="float-none w-auto px-1 fs-5">
            Daftar Alat Ukur ({{ data.list_kompetensi.length }})
          </legend>

          <div
            v-for="(kompetensi, index) in data.list_kompetensi"
            :key="kompetensi.idkompetensi"
            class="mym-competency-card mb-3"
          >
            <div class="mym-competency-header">
              <div class="mym-number">{{ index + 1 }}</div>

              <div class="mym-competency-content">
                <div class="mym-competency-title">
                  {{ kompetensi.nama_kompetensi }}
                </div>

                <div class="mym-tags">
                  <span
                    class="mym-badge mym-soft-badge-primary text-nowrap"
                    :class="
                      kompetensi.status_peserta.tipe_kompetensi == 'CORE'
                        ? 'mym-badge-primary'
                        : 'mym-badge-dark'
                    "
                  >
                    <i class="fas fa-signal"></i>
                    {{ kompetensi.status_peserta.tipe_kompetensi }}
                  </span>
                  <span class="mym-badge mym-soft-badge-secondary text-nowrap">
                    Level {{ kompetensi.level_kompetensi_idlevel_kompetensi }}
                  </span>
                  <span
                    class="mym-badge mym-soft-badge-info fw-bold text-nowrap"
                    title="Durasi"
                  >
                    <i class="fa fa-stopwatch me-1"></i>
                    {{ kompetensi.timer }} Menit
                  </span>
                  <span
                    class="mym-badge mym-soft-badge-danger fw-bold text-nowrap"
                    title="Durasi"
                  >
                    <i class="fa fa-tasks me-1"></i>
                    {{ kompetensi.jumlah_soal }} soal
                  </span>
                </div>

                <div>
                  <span
                    v-if="kompetensi.status_peserta.status === 1"
                    class="mym-badge mym-badge-light py-1 px-3 text-nowrap"
                  >
                    <i class="fas fa-play"></i> Belum Mengerjakan
                  </span>

                  <span
                    v-else-if="kompetensi.status_peserta.status === 2"
                    class="mym-badge mym-badge-warning py-1 px-3 text-nowrap"
                  >
                    <i class="fas fa-hourglass"></i> Sedang Mengerjakan
                  </span>

                  <span
                    v-else-if="
                      kompetensi.status_peserta.status === 3 &&
                      kompetensi.status_peserta.remidi === 0
                    "
                    class="mym-badge mym-soft-badge-success text-nowrap"
                  >
                    <i class="fas fa-check-circle"></i> Selesai
                  </span>

                  <span
                    v-else-if="
                      kompetensi.status_peserta.status === 3 &&
                      kompetensi.status_peserta.remidi > 0
                    "
                    class="mym-badge mym-badge-danger py-1 px-3 text-nowrap"
                  >
                    <i class="fas fa-redo"></i> Uji Ulang
                  </span>

                  <span
                    v-else-if="kompetensi.status_peserta.status === 4"
                    class="mym-badge mym-badge-dark py-1 px-3 text-nowrap"
                  >
                    <i class="fas fa-stop-circle"></i> Dihentikan
                  </span>

                  <span v-else>-</span>
                </div>
              </div>
            </div>

            <!-- Button Setting -->
            <div>
              <span
                v-if="
                  kompetensi.status_peserta.status === 3 &&
                  kompetensi.status_peserta.remidi === 0
                "
                >-</span
              >

              <button
                v-else-if="
                  data.status_jadwal != 1 ||
                  !isDateBetweenStartAndEnd(
                    data.waktu_mulai,
                    data.waktu_selesai
                  ) ||
                  data.is_mulai_jadwal == 0 ||
                  data.is_mulai_batch == 0
                "
                type="button"
                class="mym-btn-primary"
                :class="{
                  'mym-btn-primary':
                    data.status_jadwal != 1 ||
                    !isDateBetweenStartAndEnd(
                      data.waktu_mulai,
                      data.waktu_selesai
                    ) ||
                    data.is_mulai_jadwal == 0 ||
                    data.is_mulai_batch == 0,
                }"
              >
                <span
                  v-if="data.is_mulai_jadwal == 0 || data.is_mulai_batch == 0"
                  >Belum Mulai</span
                >
                <span v-else>Mulai Asesmen</span>
              </button>

              <button
                v-else-if="kompetensi.status_peserta.status === 1"
                type="button"
                class="mym-btn-primary"
                @click="
                  pindahKeHalamanTujuan(
                    kompetensi.idkompetensi,
                    data.idjadwal_peserta,
                    data.idjadwal,
                    data.jadwal_batch_idjadwal_batch,
                    kompetensi.timer,
                    kompetensi.level_kompetensi_idlevel_kompetensi,
                    kompetensi.status_peserta.idstatus_peserta,
                    kompetensi.nama_kompetensi
                  )
                "
              >
                Mulai Asesmen
              </button>

              <button
                v-else-if="kompetensi.status_peserta.status === 2"
                type="button"
                class="mym-btn-warning"
                :class="{
                  'mym-btn-danger': !isDateBetweenStartAndEnd(
                    data.waktu_mulai,
                    data.waktu_selesai
                  ),
                }"
                @click="
                  pindahKeHalamanTujuan(
                    kompetensi.idkompetensi,
                    data.idjadwal_peserta,
                    data.idjadwal,
                    data.jadwal_batch_idjadwal_batch,
                    kompetensi.timer,
                    kompetensi.level_kompetensi_idlevel_kompetensi,
                    kompetensi.status_peserta.idstatus_peserta,
                    kompetensi.nama_kompetensi
                  )
                "
                :disabled="
                  !isDateBetweenStartAndEnd(
                    data.waktu_mulai,
                    data.waktu_selesai
                  )
                "
              >
                Lanjutkan Asesmen
              </button>

              <button
                v-else-if="
                  kompetensi.status_peserta.status === 3 &&
                  kompetensi.status_peserta.remidi == 2
                "
                type="button"
                class="mym-btn-success"
              >
                Selesai
              </button>
              <button
                v-else-if="kompetensi.status_peserta.status === 4"
                type="button"
                class="mym-btn-dark"
                disabled
              >
                Dihentikan
              </button>

              <span v-else>-</span>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>
